module.exports = __webpack_public_path__ + "assets/img/studio-agency.2091af11.png";